import Vue from 'vue'
import { $, sleep, requestAnimationFrame, cancelAnimationFrame } from '@/utils/helpers'

interface HnadleScrollSelector {
  distance: number
  totop?(): void
  tobottom(): void
  selector: string
}

export default Vue.extend({
  data() {
    return {
      $_tobottom: null,
      $_totop: null,
      $_target: null,
      $_distance: 500,
      $_isSetHandleScroll: false,
      $_vsFrameId: null,
      $_oldOffset: 0,
      $_oldScrollheight: 0,
      $_isScrollUpVS: false
    }
  },
  destroyed() {
    if (this.$_isSetHandleScroll) {
      window.removeEventListener('scroll', this.$_handleScroll, false)
    }

    if (this.$_target) {
      this.$_target.removeEventListener('scroll', this.$_handleScroll, false)
      this.$_target = null
    }
  },
  methods: {
    /**
     * スクロールの監視をセット
     */
    $_setHandleScroll(distance: number = 500, tobottom: Function, totop?: Function) {
      this.$_isSetHandleScroll = true
      this.$_distance = distance
      this.$_totop = totop
      this.$_tobottom = tobottom
      window.addEventListener('scroll', this.$_handleScroll, false)
    },

    $_setHandleScrollSelector({ distance, tobottom, totop, selector }: HnadleScrollSelector) {
      this.$_isSetHandleScroll = true
      this.$_distance = distance || 500
      this.$_totop = totop
      this.$_tobottom = tobottom
      this.$_target = document.querySelector(selector)
      this.$_target.addEventListener('scroll', this.$_handleScroll, false)
    },

    /**
     * bottom 到達判定
     */
    $_handleScroll() {
      if (this.$_vsFrameId) {
        return
      }
      this.$_vsFrameId = requestAnimationFrame(() => {
        let offset, bottom
        if (this.$_target) {
          offset = this.$_target.scrollTop
          bottom = this.$_target.scrollHeight - window.innerHeight
        } else {
          const scroll = this.$_getRootScroll()
          offset = scroll ? ~~scroll.top : 0
          bottom = this.$root.$el['offsetHeight'] - window.innerHeight
        }

        this.$_isScrollUpVS = this.$_oldOffset > offset
        this.$_oldOffset = offset
        if (this.$_isScrollUpVS && typeof this.$_totop === 'function' && offset < this.$_distance) {
          this.$_totop()
        }
        if (
          !this.$_isScrollUpVS &&
          typeof this.$_tobottom === 'function' &&
          offset > bottom - this.$_distance
        ) {
          if (this.$_target) {
            this.$_oldScrollheight = this.$_target.scrollHeight
          }
          this.$_tobottom()
        }

        if (this.$_target) {
          // スクロール位置を保存
          this.$store.commit(`${this.$store.getters.fromStoreModuleName}/setSavedPosition`, {
            x: 0,
            y: offset
          })
        }

        cancelAnimationFrame(this.$_vsFrameId)
        this.$_vsFrameId = null
      })
    },

    /**
     * Store module に保存されている savedPosition でスクロール位置を復元する
     */
    $_restoreSavedPosition(storeModuleName: string) {
      const savedPosition = this.$store.getters[`${storeModuleName}/savedPosition`]
      if (!savedPosition) return
      window.scrollTo(0, savedPosition.y)
    }
  }
})
